import { pageSelectorGenerator } from '@test/pageSelectors';

export const GiftCardSelectors = pageSelectorGenerator('GiftCard', ['ContainerElement']);
